module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQxNiA2NGMxOTQuNCAwIDM1MiAxNTcuNiAzNTIgMzUyYTM1MC40IDM1MC40IDAgMCAxLTYyIDE5OS42bDIyMC40IDIyMC4zYTY0IDY0IDAgMCAxLTg2LjQgOTQuM2wtNC4xLTMuNy0yMjAuMy0yMjAuNEEzNTAuNCAzNTAuNCAwIDAgMSA0MTYgNzY4QzIyMS42IDc2OCA2NCA2MTAuNCA2NCA0MTZTMjIxLjYgNjQgNDE2IDY0eiBtMCA5NmEyNTYgMjU2IDAgMSAwIDAgNTEyIDI1NiAyNTYgMCAwIDAgMC01MTJ6IiBmaWxsPSIjMCIgcC1pZD0iMzIzOCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Search-filled.svg
// module id = f4Zy
// module chunks = 75